import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../http.service';
import { AuthenticationService } from '../_services';
// para formulario
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { MatSnackBar} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { NuevaTransactionService } from '../_services'



/**
 * @title Table retrieving data through HTTP
 */
@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})



export class TransactionsComponent implements AfterViewInit {
  displayedColumns: string[] = ['created', 'consignor_name', 'description', 'code', 
  'monto_base', 'iva', 'saldo_antes', 'variacion_saldo', 'saldo_despues', 
  'iva_antes', 'iva_despues'];
  transactionDatabase: TransactionDatabase | null;
  data: TransactionIssue[] = [];
  coins;
  la_fecha_corte;

  currentRole: any;

  // para formulario 
  transactionForm: FormGroup;
  form_transaction: []
  nueva_transaction: any = {};


  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  constructor(
    private formBuilder: FormBuilder, // para formulario
    private snackBar: MatSnackBar, // para confirmacion de formulario
    private _httpClient: HttpClient, 
    private _hs: HttpService,
    private authenticationService: AuthenticationService,
    private nueva_transactionService: NuevaTransactionService,
  ) { 
    this.authenticationService.currentRole.subscribe(x => this.currentRole = x);
  }



  ngOnInit() {
    this.transactionForm = this.formBuilder.group({
      consignor_id: ['', Validators.required],
      description: ['', Validators.required],
      code: ['', Validators.required],
      monto_base: ['', Validators.required],
      iva: ['', Validators.required],
    });
  }

  onSubmitT() {
    // console.log("submitted el form entrada cedos")
    this.nueva_transaction["consignor_id"] = this.transactionForm.value.consignor_id
    this.nueva_transaction["description"] = this.transactionForm.value.description
    this.nueva_transaction["code"] = this.transactionForm.value.code
    this.nueva_transaction["monto_base"] = this.transactionForm.value.monto_base
    this.nueva_transaction["iva"] = this.transactionForm.value.iva
    

    // console.log(this.nueva_transaction)
     this.nueva_transactionService.registrar(this.nueva_transaction)
            .pipe(first())
            .subscribe(
                data => {
                   //  this.router.navigate([this.returnUrl]);
                   // console.log("guardado recibido en component")
                   // console.log("la data es")
                   // console.log(data)
                   //this.openSnackBar("Compra guardada", "OK")
                   this.snackBar.open("Transaction guardada", "OK", {                      
                      duration: 2000,
                    });
                   
                },
                error => {
                  //  this.error = error;
                    // this.loading = false;
                    // console.log("error recibido en component")
                });
  }



  ngAfterViewInit() {

    // this._hs.ffs_pendientes().subscribe(res => {
    //   this.coins = <any>res;
    //   this.la_fecha_corte = "el primer cambio";
    //   console.log("vamos con el resultado en ngAfterViewInit")
    //   console.log(this.coins);
    // } );

    

    this.transactionDatabase = new TransactionDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);


    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.transactionDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
       //    console.log("vamos en la 72")
	    		// console.log(data)

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  


  }

  setClasses(fecha_creado) {
    let hoy = new Date();
    let fecha_pago = new Date(fecha_creado);

    let fecha_corte = new Date(this.coins);


   
    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }




}



export interface TransactionApi {
  items: TransactionIssue[];
  total_count: number;
}

export interface TransactionIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class TransactionDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number): Observable<TransactionApi> {
    // console.log(sort)
    // console.log(order)
    // console.log(page)
    const href = 'https://vertigofin.herokuapp.com/query_transactions.json' + page;
    // const href = 'http://localhost:3000/query_sales.json' + page;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}`;

    return this._httpClient.get<TransactionApi>(requestUrl);
  }
}
